import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { getCurrentMonthDateRange } from 'src/utils/date/dateUtils';

import { defaultPUR1040_R01DetailDto, defaultPUR1040_R01HeaderDto, PUR1040_R01DetailDto, PUR1040_R01HeaderDto } from './Dto_PUR1040_R01';

export interface PUR1040_R01Filter {
	compCd: string;
	dateRange: DateRange | undefined;
	logicCenter: string;
	itemGroup: string;
	brandCd: string;
	empNo: string;
	empNm: string;
	customNm: string;
	customCd: string;
}
export interface Store_PUR1040_R01 {
    PUR1040_R01Filter: PUR1040_R01Filter;
    PUR1040_R01PastFilter: PUR1040_R01Filter;
    setPUR1040_R01Filter: (filter: Partial<Store_PUR1040_R01['PUR1040_R01Filter']>) => void;
    setPUR1040_R01PastFilter: (filter: Store_PUR1040_R01['PUR1040_R01PastFilter']) => void;

	

	// ====== 견적 리스??�??�택/?�집 ======
    PUR1040_R01List: PUR1040_R01HeaderDto[];
    setPUR1040_R01List: (dataList: PUR1040_R01HeaderDto[]) => void;

    editPUR1040_R01: PUR1040_R01HeaderDto | null;
    setEditPUR1040_R01: (editSale: PUR1040_R01HeaderDto | null) => void;

    selectedPUR1040_R01: PUR1040_R01HeaderDto | undefined;
    setSelectedPUR1040_R01: (data: PUR1040_R01HeaderDto | undefined) => void;
    initSelectedPUR1040_R01: () => void;

	// ====== ?�세(?�테?? ???�택/??�� 관�?======
    deletedPUR1040_R01DetailList: string[];
    setDeletedPUR1040_R01DetailList: (idList: string[]) => void;
    addDeletedPUR1040_R01DetailList: (idList: string[]) => void;
    removeDeletedPUR1040_R01DetailList: (idList?: string[]) => void;

	// ====== 견적 ?�세(?�테?? ?�이??======
    PUR1040_R01DetailList: PUR1040_R01DetailDto[];
    setPUR1040_R01DetailList: (data: PUR1040_R01DetailDto[]) => void;
    insertPUR1040_R01DetailList: (data: PUR1040_R01DetailDto[], index?: number) => void;
    removePUR1040_R01DetailList: (index: number) => void;
    updatePUR1040_R01DetailList: (index: number, data: PUR1040_R01DetailDto) => void;

	// ====== ?�택(?�테?? ???�택/??�� 관�?======
    selectedPUR1040_R01DetailList: string[];
    setSelectedPUR1040_R01DetailList: (idList: string[]) => void;
    addSelectedPUR1040_R01DetailList: (idList: string[]) => void;
    removeSelectedPUR1040_R01DetailList: (idList?: string[]) => void;
    initSelectedPUR1040_R01DetailList: () => void;

    originalPUR1040_R01DetailList: PUR1040_R01DetailDto[];
    setOriginalPUR1040_R01DetailList: (data: PUR1040_R01DetailDto[]) => void;

	// ====== 컬럼 ?�태(그리?? ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	

	// ====== 초기??======
	initData: () => void;

}

export const defaultPUR1040_R01Filter : PUR1040_R01Filter = {
	compCd: '',
	dateRange: getCurrentMonthDateRange(), 
	logicCenter: '',
	itemGroup: '',
	brandCd: '',
	empNo: '',
	empNm: '',
	customCd: '',
	customNm: '',
};

export const usePUR1040_R01Store = create<Store_PUR1040_R01>((set) => ({
    PUR1040_R01Filter: defaultPUR1040_R01Filter,
    PUR1040_R01PastFilter: defaultPUR1040_R01Filter,
    setPUR1040_R01Filter: (update) => set((state) => ({
        PUR1040_R01Filter: {
            ...state.PUR1040_R01Filter,
            ...update
        }
    })),
    setPUR1040_R01PastFilter: (filter: Store_PUR1040_R01['PUR1040_R01PastFilter']) => set((state) => {
		return {
			...state,
			PUR1040_R01PastFilter: filter
		}
	}),

	// ====== 견적 리스??�??�택/?�집 ======
    PUR1040_R01List: [],
    setPUR1040_R01List: (dataList: PUR1040_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			PUR1040_R01List: dataList
		}
	}),

    editPUR1040_R01: defaultPUR1040_R01HeaderDto,
    setEditPUR1040_R01: (editSale: PUR1040_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editPUR1040_R01: editSale
		}
	}),

    selectedPUR1040_R01: undefined,
	// 매출 선택 ??editSales???기??
    setSelectedPUR1040_R01: (data: PUR1040_R01HeaderDto | undefined) => set((state) => {
		let editData = null;
		if (data) {
			editData = { ...data };
		}
        return { selectedPUR1040_R01: data, editPUR1040_R01: editData, detailScrollTop: null };
	}),
    initSelectedPUR1040_R01: () => set({ selectedPUR1040_R01: undefined, editPUR1040_R01: defaultPUR1040_R01HeaderDto, PUR1040_R01DetailList: [] }),

	// ====== 견적 세(디테일) 데이터======
    PUR1040_R01DetailList: [],
    setPUR1040_R01DetailList: (data: PUR1040_R01DetailDto[]) => set((state) => {
		const newList = data.map((item, index) => ({
			...item,
			valueIndex: item.valueIndex > 0 ? item.valueIndex : index + 1,
			orderIndex: item.orderIndex > -1 ? item.orderIndex : index + 1,
			orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
		}));
		
		return {
			...state,
            PUR1040_R01DetailList: newList
		};
	}),
    insertPUR1040_R01DetailList: (data: PUR1040_R01DetailDto[], index?: number) => set((state) => {
        const newPUR1040_R01DetailList = [...state.PUR1040_R01DetailList];

		//let valueIndex = newSYS4100_R01List.length + 1;
        let valueIndex = Math.max(0, ...newPUR1040_R01DetailList.map(item => item.valueIndex || 0)) + 1;
		let targetOrderIndex = index ? index : 1;
		// 같은 orderIndex가 있는 것들 중에서 orderIndexSeq 값을 찾는다
        const maxOrderIndexSeq = Math.max(0, ...newPUR1040_R01DetailList
			.filter(item => item.orderIndex === targetOrderIndex)
			.map(item => item.orderIndexSeq || 0)
		);
		let targetOrderIndexSeq = maxOrderIndexSeq + 1;
		// console.log('valueIndex : ', valueIndex 
		// 				+ ' 멤버 index : ' + index
		// 				+ ' 최종 orderIndex : ' + targetOrderIndex
		// 				+ ' 최종 orderIndexSeq : ' + targetOrderIndexSeq
		// 			);
		
        const newData = data.map(item => ({ ...defaultPUR1040_R01DetailDto, ...item, 
			valueIndex: valueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: targetOrderIndexSeq
		}));
		if (index !== undefined) {
            newPUR1040_R01DetailList.splice(index, 0, ...newData);
		} else {
            newPUR1040_R01DetailList.push(...newData);
		}
		return {
			...state,
            PUR1040_R01DetailList: newPUR1040_R01DetailList
		}
	}),
    removePUR1040_R01DetailList: (index: number) => set((state) => {
        const newPUR1040_R01DetailList = [...state.PUR1040_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
            PUR1040_R01DetailList: newPUR1040_R01DetailList
		}
	}),
    updatePUR1040_R01DetailList: (valueIndex: number, data: PUR1040_R01DetailDto) => set((state) => {
        const _PUR1040_R01DetailList = state.PUR1040_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
            PUR1040_R01DetailList: _PUR1040_R01DetailList
		}
	}),
	
	// ====== 행삭제 테이블(품목테이블)======
    deletedPUR1040_R01DetailList: [],
    setDeletedPUR1040_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
            deletedPUR1040_R01DetailList: idList
		}
	}),
    addDeletedPUR1040_R01DetailList: (idList: string[]) => set((state) => {
        const _deletedDetailList = [...state.deletedPUR1040_R01DetailList];

        for(const valueIndex of idList) {
            const isInserted = state.PUR1040_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
            const isModified = state.PUR1040_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
            deletedPUR1040_R01DetailList: _deletedDetailList
		}
	}),
    removeDeletedPUR1040_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
        deletedPUR1040_R01DetailList: [...state.deletedPUR1040_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

    selectedPUR1040_R01DetailList: [],
    setSelectedPUR1040_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
            selectedPUR1040_R01DetailList: idList
		}
	}),
    addSelectedPUR1040_R01DetailList: (idList: string[]) => set((state) => {
        const _selectedPUR1040_R01DetailList = [...state.selectedPUR1040_R01DetailList];
		if(idList.length > 0) {
            _selectedPUR1040_R01DetailList.push(...idList);
		}
		return {
			...state,
            selectedPUR1040_R01DetailList: _selectedPUR1040_R01DetailList
		}
	}),
    removeSelectedPUR1040_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
        selectedPUR1040_R01DetailList: [...state.selectedPUR1040_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
    initSelectedPUR1040_R01DetailList: () => set({ selectedPUR1040_R01DetailList: [] }),

    originalPUR1040_R01DetailList: [],
    setOriginalPUR1040_R01DetailList: (data: PUR1040_R01DetailDto[]) => set((state) => {
        let newList: PUR1040_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
                ...defaultPUR1040_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
            originalPUR1040_R01DetailList: newList
		}
	}),

	// ====== 컬럼 ?�태(그리?? ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
						

	// ====== 초기화======
    initData: () => set((state) => ({
		...state,
        PUR1040_R01Filter: defaultPUR1040_R01Filter,
        PUR1040_R01PastFilter: defaultPUR1040_R01Filter,
        PUR1040_R01List: [],
        selectedPUR1040_R01: undefined,
        PUR1040_R01DetailList: [],
        deletedPUR1040_R01DetailList: [],
        selectedPUR1040_R01DetailList: [],
        originalPUR1040_R01DetailList: [],
        editPUR1040_R01: defaultPUR1040_R01HeaderDto,
		allCount: 0,
		
		columnState: null,
		detailColumnState: null,
		scrollTop: null,
		detailScrollTop: null,
	})),

	
}));
